import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Activity } from "@/lib/api";
import { Link } from "react-router-dom";

interface ActivityCardProps {
  activity: Activity;
}

const ActivityCard = ({ activity }: ActivityCardProps) => {
  return (
    <Card className="overflow-visible group hover-lift">
      <div className="relative">
        <div className="aspect-video overflow-hidden rounded-t-[var(--radius)]">
          <img
            src={activity.image}
            alt={activity.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
        {activity.ribbonEnabled && activity.ribbonText && activity.ribbonHomepage !== false && (
          <div className="ribbon-wrapper ribbon-wrapper--lg">
            <div className={`corner-ribbon ${activity.ribbonColor === 'yellow' ? 'corner-ribbon--yellow' : ''}`}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{activity.ribbonText}</div>
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-bold text-foreground mb-2">{activity.title}</h3>
        <p className="text-lg font-semibold text-primary mb-3">{activity.price}</p>
        <p className="text-muted-foreground mb-4 whitespace-pre-line">{activity.description}</p>
        <Button
          className="w-full bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
          asChild
        >
          <Link to={`/activiteiten#${activity.id}`}>Meer informatie</Link>
        </Button>
      </div>
    </Card>
  );
};

export default ActivityCard;
